import Edit from './PaymentMethodPriceTablesEdit'

const PaymentMethodPriceTables = {
  Edit,
}

export default PaymentMethodPriceTables
